<template>
  <el-card>
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
           <el-dropdown size="small" type="default" class="">
             <el-button type="primary" size="small">
               <i class="el-icon-download"></i>
             </el-button>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
               <el-dropdown-item @click.native="downloadSalesReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
           <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
  			</div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>

      </p>
      <div id="printMe">
        <div class="card-base card-alt">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <div class="widget p-20">
                <div class="text-uppercase text-right flex">
                  <div class="box grow">
                    <h3 class="m-0">{{$n(stats.total_value, 'currency','CAD')}}</h3>
                    <p class="m-0">$ Ventes</p>
                  </div>
                  <div class="icon-box ph-15 accent-text">
                    <i class="mdi mdi-currency-usd"></i>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <div class="widget p-20">
                <div class="text-uppercase text-right flex">
                  <div class="box grow">
                    <h3 class="m-0">{{$n(stats.total_agency_fee, 'currency','CAD')}}</h3>
                    <p class="m-0">$ frais d'agence</p>
                  </div>
                  <div class="icon-box ph-15 accent-text">
                    <i class="mdi mdi-currency-usd"></i>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <div class="widget p-20">
                <div class="text-uppercase text-right flex">
                  <div class="box grow">
                    <h3 class="m-0">{{$n(stats.discount_amount, 'currency','CAD')}}</h3>
                    <p class="m-0">Rabais</p>
                  </div>
                  <div class="icon-box ph-15 accent-text">
                    <i class="mdi mdi-currency-usd"></i>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <div class="widget p-20">
                <div class="text-uppercase text-right flex">
                  <div class="box grow">
                    <h3 class="m-0">{{stats.qty}}</h3>
                    <p class="m-0">Qty</p>
                  </div>
                  <div class="icon-box ph-15 accent-text">
                    <i class="mdi mdi-finance"></i>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <div id="chart" :style="{height:'500px',width:'100%'}"></div>
        </el-row>
        <el-row>
          <el-pagination
            :small="pagination.small"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.sizes"
            :page-size.sync="pagination.size"
            :layout="pagination.layout"
            :total="total"
            :hide-on-single-page="true"
          ></el-pagination>
          <el-table :data="listInPage" :style="tableWidth" stripe empty-text="Il n'y a aucune vente pour cette période">
            <el-table-column   label="Date" prop="date"  width="100">
              <template slot-scope="scope">
                <span class="fs-12">{{_moment(scope.row.date)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Client" prop="customer_name"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-link :underline="false" @click="openCustomer(scope.row.customer_id)" type="primary"><span class="fs-12">{{(scope.row.customer_name)}}</span></el-link><el-link :href="'/customers/'+scope.row.customer_id" target="_blank" type="primary" :underline="false"><i class="mdi mdi-launch ml-10"></i></el-link>
              </template>
            </el-table-column>
            <el-table-column label="Document" prop="document_number"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span class="fs-12">{{scope.row.document_number}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Produit" :show-overflow-tooltip="true" prop="product_name" >
              <template slot-scope="scope">
                <span class="fs-12">{{(scope.row.product_name)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Quantité" :show-overflow-tooltip="true" prop="qty_ordered" >
              <template slot-scope="scope">
                <span class="fs-12">{{(scope.row.qty_ordered)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Valeur" :show-overflow-tooltip="true" prop="default_price" >
              <template slot-scope="scope">
                <span class="fs-12">{{(scope.row.default_price)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Frais d'agence" :show-overflow-tooltip="true" prop="agency_fee">
              <template slot-scope="scope">
                <span class="fs-12">{{(scope.row.agency_fee)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Rabais" :show-overflow-tooltip="true" prop="discount_amount">
              <template slot-scope="scope">
                <span class="fs-12">{{(scope.row.discount_amount)}}</span>
              </template>
            </el-table-column>
            <el-table-column   label="Rep." :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span class="fs-12">{{scope.row.sales_rep_first_name}} {{scope.row.sales_rep_last_name}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :small="pagination.small"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.sizes"
            :page-size.sync="pagination.size"
            :layout="pagination.layout"
            :total="total"
            :hide-on-single-page="true"
          ></el-pagination>
        </el-row>
      </div>
    <reportFilter v-if="!loading"
                  :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :predefinedPeriod="predefinedPeriod"
                  :period="period"
                  :startDate="this.filters.startDate"
                  :endDate="this.filters.endDate"
                  :customerFilter="true"
                  :customer="selectedCustomer"
                  :providerFilter="true"
                  :provider="selectedProvider"
                  :inventories="inventories"
                  :selectedInventories="filters.inventories"
                  :selectedCustomerClasses="filters.customer_classes"
                  :reps="salesRep"
                  :selectedReps="getUserById(filters.reps)"
                  :customer_classes="customerClasses"
                  :productFilter="true"
                  :selectedProduct="this.filters.product"
                  @applyFilter="handleFilter">
    </reportFilter>
    <WatingDialog :visible="loading" content="Veuillez patienter pendant que nous préparons votre rapport. Cela peut prendre plusieurs secondes."></WatingDialog>
</div>
<!-- </el-row> -->
</el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import systemAPI from '@/services/API/system.js'
import moment from 'moment'
// import { extendMoment } from 'moment-range';
// const moment = extendMoment(Moment);
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import * as echarts from 'echarts';
import Promise from "bluebird";
import WatingDialog from '@/components/waiting-dialog'

export default {
  name : "Sales-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      chart: null,
      stats : {total_value : 0, total_agency_fee:0, qty:0, qty_standardize:0,discount_amount:0},
      salesStatisticByDate : {value : [], agency_fee : [], sales : [], discount : []},
      output : null,
      data : [],
      loading:true,
      statusCode : [],
      filters : {
        range : 'MONTH',
        startDate : null,
        endDate : null,
        statuses : [],
        customerId : null,
        providerId: null,
        groupBy : 'CUSTOMER',
        reps : [],
        customer_classes : [],
        products : [],
      },
      customerName : null,
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
    };
  },
  components : {
    reportFilter,
    WatingDialog
  },
  computed : {
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    selectedProvider(){
      if(this.filters.providerId!=null && this.filters.providerId!=undefined){
        return {id:this.filters.providerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    reportCode(){
      return this.$route.params.code;
    },
    usableData(){
      return this.data.details;
    },
    currentMonthDates(){

      if(this.filters.startDate!=null){
        return new Array(moment(this.filters.startDate).daysInMonth()).fill(null).map((x, i) => moment(this.filters.startDate).startOf('month').add(i, this.interval));
      }else{
        return new Array(moment().daysInMonth()).fill(null).map((x, i) => moment().startOf('month').add(i, 'days'));
      }


    },
    interval(){
      let startDate = moment(this.filters.startDate);
      let endDate = moment(this.filters.endDate);
      let interval = 'months';
      const diff = endDate.diff(startDate, 'days');
      if (diff <= 30) {
        interval = 'days'
      } else if (diff > 30 && diff <= 90) {
        interval = 'weeks'
      }
      return interval;
    },
    dateRange(){
      let data = [];
      if(this.filters.range=='MONTH' || this.filters.range=='LAST_MONTH'){
        _.forEach(this.currentMonthDates, d=>{
          data.push(d.format('YYYY-MM-DD'));
        })
      } else if(this.filters.range=='FISCAL_YEAR' || this.filters.range=='LAST_FISCAL_YEAR'){
        let date = moment(this.filters.startDate)

        while(moment(this.filters.endDate).isAfter(date)){
          data.push(date.format('YYYY-MM'))
          date = date.add(1,'months');
        }

      } else {
        let startDate = moment(this.filters.startDate);
        let endDate = moment(this.filters.endDate);
        // console.log("date Range custom")

        while(moment(this.filters.endDate).isAfter(startDate)){
          data.push(startDate.format('YYYY-MM-DD'));
          startDate = startDate.add(1,this.interval);
        }
      }
      return data;
    },
    axis(){
      const data = [];
      if(this.filters.range=='MONTH' || this.filters.range=='LAST_MONTH'){
        _.forEach(this.dateRange, d=>{
          data.push(moment(d).format('DD'));
        })
      }else {
        if (this.interval === 'months') {
          _.forEach(this.dateRange, d=>{
            data.push(moment(d).format('YYYY-MM'));
          })
        } else {
          _.forEach(this.dateRange, d=>{
            data.push(moment(d).format('YYYY-MM-DD'));
          })
        }

      }

      return data;
    },
    total() {
			return this.usableData != null ? this.usableData.length : 0;
		},
    listInPage(){
      if (this.usableData == null) return [];
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      return this.usableData.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
    salesRep(){
      return this.filterUserWithRoleRep;
    },
    ...mapState('inventory',['inventories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
    ...mapState('controlData',['customerClasses']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'getCurrentUserId', 'isCurrentUserAdmin']),

  },
  methods : {
    print(){
       const element = window.document.getElementById('page-panel');

       _.forEach(element.getElementsByTagName('table'), t=>{
         t.style.width='100%';
         t.style['table-layout']='auto';
       })
       const url = '';
       const win = window.open('', '', 'left=0,top=0,width=800,height=800,toolbar=yes,scrollbars=yes,status=yes', true);

        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        win.document.write(`
        <html style="overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset">
          <head>
            <title>${window.document.title}</title>
            <styles>${stylesHtml}</styles>
          </head>
          <body style="overflow-x: hidden;overflow-y: auto;height:auto;width:100%;display:block;position:unset;">
            ${element.innerHTML}
          </body>
        </html>
      `);
      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
      }, 1000);


    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
			this.$router.push(index);
    },openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    downloadSalesReport(type='csv'){
      this.loading = true;
      let filename = 'SALES_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      filename+="."+type;
      let params = this.prepareBuildRequest();
      params.format=type;
      return salesAPI.downloadSalesReport(this.reportCode, filename, params)
        .then(() => {
          this.loading = false;
        }).catch(err=> {
          this.loading = false;

        })
    },
    handleFilter(filters){
      let inventories = [];
      _.forEach(filters.inventories, m=>{
        inventories.push(m.id);
      })
      localStorage.sales_inventories = JSON.stringify(inventories);
      localStorage.sales_range=filters.period.code;
      localStorage.sales_startDate = filters.dateRange[0];
      localStorage.sales_endDate = filters.dateRange[1];
      localStorage.sales_customerId = filters.customer!=null ? filters.customer.id : undefined;
      localStorage.sales_providerId = filters.provider!=null ? filters.provider.id : undefined;
      let reps = [];
      _.forEach(filters.reps, m=>{
        reps.push(m.id);
      })
      localStorage.sales_reps = JSON.stringify(reps);

      localStorage.sales_product = JSON.stringify(filters.product);

      let customer_classes = [];
      _.forEach(filters.customer_classes, m=>{
        customer_classes.push(m.id);
      })
      localStorage.sales_customer_classes = JSON.stringify(customer_classes);


      if(filters.customer!=null){
        localStorage.sales_customerName = filters.customer.name;
      }


      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    prepareBuildRequest () {
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD Z');
      }

      filters.productId = filters.product != null ? filters.product.id : undefined;
      delete filters.product;
      return filters;
    },
    fetchData(){
      this.loading = true;
      this.resetChartValues();
      this.stats.qty=0;
      this.stats.total_value=0;
      this.stats.total_agency_fee=0;
      this.stats.qty_standardize = 0;
      this.stats.discount_amount = 0;
      let filters = this.prepareBuildRequest();

      return salesAPI.getReportInfo(this.reportCode, filters)
        .then(data=>{
          this.data = data;
          this.parseData();
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    parseData(){
      let diff = 1;
      let unit = 'D'
      if (this.interval === 'months') {
        unit = 'M';
      } else if (this.interval === 'weeks'){
        unit = "W";
      } else {
        unit = "D";
      }

      // const startDateIndex = moment(this.filters.startDate).format(unit);
      // console.log("startDateIndex : ", startDateIndex);

      this.stats.total_value = 0;
      _.forEach(this.data.summary, d=>{

        let index = moment(d.date).diff(moment(this.filters.startDate), this.interval);

        this.salesStatisticByDate.value[index] = Math.round((this.salesStatisticByDate.value[index] + d.value_by_date) *100) / 100;
        this.stats.total_value = Math.round((this.stats.total_value + d.value_by_date)*100) / 100;
        this.salesStatisticByDate.agency_fee[index] = Math.round((this.salesStatisticByDate.agency_fee[index] + d.agency_fee_by_date) * 100) / 100;
        this.stats.total_agency_fee = Math.round((this.stats.total_agency_fee + d.agency_fee_by_date) * 100) /100;
        this.salesStatisticByDate.sales[index] = Math.round((this.salesStatisticByDate.sales[index] + d.default_price_by_date) * 100) /100;
        this.salesStatisticByDate.discount[index] = Math.round((this.salesStatisticByDate.discount[index] + d.discount_amount_by_date) * 100) /100;
        this.stats.qty+=d.qty;
        this.stats.qty_standardize=Math.round((this.stats.qty_standardize+parseFloat(d.qty_9l))*100)/100;
        this.stats.discount_amount = Math.round((this.stats.discount_amount + d.discount_amount_by_date) *100) /100;
      })

      _.forEach(this.data.details, d=>{

        d.agency_fee = Math.round(d.agency_fee * 100) / 100;
        d.default_price = Math.round(d.default_price * 100) / 100;
      })



      this.initChart();
    },
    setFilters(){

      if(localStorage.sales_range==null){
        localStorage.sales_range='MONTH';
      }
      this.customerName = localStorage.invoices_detail_customerName;

      this.filters.range=localStorage.sales_range;
      this.filters.customerId=localStorage.sales_customerId!='undefined' && localStorage.sales_customerId!=null  ? parseInt(localStorage.sales_customerId) : undefined;
      this.filters.providerId=localStorage.sales_providerId!='undefined' && localStorage.sales_providerId!=null  ? parseInt(localStorage.sales_providerId) : undefined;

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.sales_startDate = this.fiscalYearDate.startDate;
        localStorage.sales_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.sales_startDate = this.lastFiscalYearDate.startDate;
        localStorage.sales_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.sales_startDate = this.month.startDate;
        localStorage.sales_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.sales_startDate = this.lastMonth.startDate;
        localStorage.sales_endDate = this.lastMonth.endDate;
      }

      this.filters.startDate = localStorage.sales_startDate;
      this.filters.endDate = localStorage.sales_endDate;

      this.filters.reps=localStorage.sales_reps!=null ? JSON.parse(localStorage.sales_reps) : [];

      this.filters.product = localStorage.sales_product !=null ? JSON.parse(localStorage.sales_product) : null;

      this.filters.customer_classes=localStorage.sales_customer_classes!=null ? JSON.parse(localStorage.sales_customer_classes) : [];
      this.filters.inventories=localStorage.sales_inventories!=null ? JSON.parse(localStorage.sales_inventories) : [];
    },
		initChart() {
			this.chart = echarts.init(document.getElementById('chart'))
			this.chart.setOption({
				//backgroundColor: '#394056',
				title: {
					top: 20,
					text: this.$i18n.t('reports.SALES.title'),
					textStyle: { fontWeight: 'normal', fontSize: 16, fontFamily:'Nunito Sans' /*color: '#F1F1F3'*/ },
					left: '1%'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: { lineStyle: { /*color: '#57617B'*/ } }
				},
				legend: {
					top: 40,
					icon: 'rect',
					itemWidth: 14,
					itemHeight: 5,
					itemGap: 13,
					data: [this.$i18n.t('reports.SALES.axis.value'), this.$i18n.t('reports.SALES.axis.agency_fee'),this.$i18n.t('reports.SALES.axis.sales'),this.$i18n.t('reports.SALES.axis.rebates')],
					right: '4%',
					textStyle: { fontSize: 12, fontFamily:'Nunito Sans' /*color: '#F1F1F3'*/ }
				},
				grid: {
					top: 100,
					left: '-5px',
					right: '30px',
					bottom: '2%',
					containLabel: true
				},
				xAxis: [{
					type: 'category',
					boundaryGap: false,
					axisLine: { lineStyle: { /*color: '#57617B'*/ } },
					data: this.axis
				}],
				yAxis: [{
					show: false,
					type: 'value',
					name: '(%)',
					axisTick: { show: false },
					axisLine: { lineStyle: { /*color: '#57617B'*/ } },
					axisLabel: {
						margin: 10,
						textStyle: { fontSize: 14 }
					},
					splitLine: { lineStyle: { color: '#eee' /*color: '#57617B'*/ } }
				}],
				series: [{
					name: this.$i18n.t('reports.SALES.axis.value'),
					type: 'line',
					smooth: true,
					symbol: 'circle',
					symbolSize: 5,
					showSymbol: false,
					lineStyle: { normal: { width: 1 } },
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(19, 206, 102, 0.3)'
							}, {
								offset: 0.8,
								color: 'rgba(19, 206, 102, 0)'
							}], false),
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						}
					},
					itemStyle: {
						normal: {
							color: 'rgb(19, 206, 102)',
							borderColor: 'rgba(19, 206, 102, 0.27)',
							borderWidth: 12
						}
					},
					data: this.salesStatisticByDate.value
				},
        {
          name: this.$i18n.t('reports.SALES.axis.sales'),
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: { normal: { width: 1 } },
          areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(193, 66, 66, 0.3)'
							}, {
								offset: 0.8,
								color: 'rgba(193, 66, 66, 0)'
							}], false),
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						}
					},
					itemStyle: {
						normal: {
							color: 'rgb(193, 66, 66)',
							borderColor: 'rgba(193, 66, 66, 0.2)',
							borderWidth: 12
						}
					},
          data: this.salesStatisticByDate.sales
        },
        {
          name: this.$i18n.t('reports.SALES.axis.agency_fee'),
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: { normal: { width: 1 } },
          areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(95, 143, 223, 0.3)'
							}, {
								offset: 0.8,
								color: 'rgba(95, 143, 223, 0)'
							}], false),
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						}
					},
					itemStyle: {
						normal: {
							color: 'rgb(95, 143, 223)',
							borderColor: 'rgba(95, 143, 223, 0.2)',
							borderWidth: 12
						}
					},
          data: this.salesStatisticByDate.agency_fee
        },
        {
          name: this.$i18n.t('reports.SALES.axis.rebates'),
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: { normal: { width: 1 } },
          areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(95, 143, 223, 0.3)'
							}, {
								offset: 0.8,
								color: 'rgba(95, 143, 223, 0)'
							}], false),
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						}
					},
					itemStyle: {
						normal: {
							color: 'rgb(255, 170, 0)',
							borderColor: 'rgba(255, 170, 0, 0.5)',
							borderWidth: 12
						}
					},
          data: this.salesStatisticByDate.discount
        }]
			})
		},
    resetChartValues(){
      _.forEach(this.dateRange, (d, index)=>{
        this.salesStatisticByDate.value[index]=0;
        this.salesStatisticByDate.agency_fee[index]=0;
        this.salesStatisticByDate.sales[index]=0;
        this.salesStatisticByDate.discount[index]=0;
      })
    },
    ...mapActions('inventory',['fetchInventories']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('controlData',['fetchCustomerClasses'])
  },
  mounted(){
    // this.initChart()
    this.setPageWidth();
    // this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.loading = true;
     if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && !this.isCurrentUserAdmin) {
        this.filters.reps = [this.getCurrentUserId];
      }
    return Promise.all([
      this.fetchAdminUsers(),
      this.fetchInventories(),
      this.fetchCustomerClasses()])
        .then(()=> this.setFilters())
        .then(() => this.fetchData())
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
